<template>
  <div>
    <remote-css href="http://winwend.net/bootstrap.css"></remote-css>

    <div id="summernote"></div>
  </div>
</template>

<script>
  /**
   * 刘植聪：20221105
   * summernote富文本框组件
   */
  import $ from 'jquery'
  export default {
    name: 'concTemplate',
    components:{
      'remote-css': {
            render(createElement) {            
              return createElement('link', { attrs: { rel: 'stylesheet', href: this.href }});
            },
            props: {
            href: { type: String, required: true },
            },
        }
    },
    props: {
      //文本框宽度
      Width:{
        type:[Number,String],
        default:null
      },
      //文本框高度
      Height:{
        type:[Number,String],
        default:600
      },
      //文本框提示语
      Placeholder:{
        type:String,
        default:'请编辑内容'
      },
      //获取文本框内容
      getValue:{
        type: Function
      },
      setValue:{
        type:String,
        default:''
      }
    },
    data(){
      return {
        content:''
      }
    },
    watch:{
      
    },
    mounted(){
      var that = this
      $('#summernote').summernote({
        height: this.Height,
        width:this.Width,
        placeholder:this.Placeholder,
        lang: 'zh-CN',
        callbacks:{
          onChange: function(contents, $editable) {
           // contents: 输入的内容
            that.content = contents;
            that.getValue(contents)
          }
        }
      });
      $("#summernote").summernote("code",this.setValue);
    },
    methods: {
      
    }
  }
</script>

<style scoped>
/* @import 'bootstrap/dist/css/bootstrap.css'; */
</style>



// WEBPACK FOOTER //
// src/components/conc/concTemplate.vue